<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="num_uc" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N° UC</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                        <b-form-datepicker
                        locale="pt-br"  
                        placeholder="Data Inicial" 
                        v-model="dt_inicio" 
                        reset-button
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px p-a-0">
                         <b-form-datepicker
                         locale="pt-br"  
                        placeholder="Data Fim" 
                        v-model="dt_fim" 
                        reset-button
                        class="form-control" 
                        :date-format-options="{day: 'numeric', month: 'numeric', year: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="tom_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Tomador</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="for_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Fornecedor</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  components: {
      Multiselect
  },
  data () {
    return {
      date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
      helpForm: new Form({params: []}),
      num_pedido: '',
      num_uc: '',
      tom_cnpj: '',
      for_cnpj: '',
      dt_inicio: '',
      dt_fim: '',
      optionsLivStatus: [],
      status: [],
      data_filter: []
    }
  },
  mounted() {
      this.getStatus();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
        this.dt_inicio_label = this.dt_inicio;
          this.dt_fim_label = this.dt_fim;
          this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
          this.dt_fim = this.formatDateSubmit(this.dt_fim);
          this.data_filter = {num_pedido: this.num_pedido,
                              num_uc: this.num_uc,
                              tom_cnpj: this.tom_cnpj,
                              for_cnpj: this.for_cnpj,
                              dt_fim: this.dt_fim,
                              dt_inicio: this.dt_inicio,
                              status: this.status}
          this.$events.fire('filter-set', this.data_filter);
          this.dt_inicio = this.dt_inicio_label;
          this.dt_fim = this.dt_fim_label;
      },
      resetFilter () {
        this.num_pedido = '';  // clear the text in text input
        this.num_uc = '';
        this.tom_cnpj = '';
        this.for_cnpj = '';
        this.dt_inicio =  '';
        this.dt_fim = '';
        this.status = '';
        this.$events.fire('filter-reset');
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      getStatus() {
          this.helpForm.params = { tabela: 'pedido_unidade_carga',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
